(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bam-cart"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.classList.add('bam-js');
  (function () {
    function counts(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('aria-hidden', n > 0 ? 'false' : 'true'); });
    }
    function change(key, qty) {
      var page = document.querySelector('[data-bam-cart-page]');
      var sid = page ? page.getAttribute('data-section-id') : null;
      var body = { id: key, quantity: qty };
      if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
      if (page) page.style.opacity = '.5';
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (sid && data.sections && data.sections[sid]) {
            var doc = new DOMParser().parseFromString(data.sections[sid], 'text/html');
            var fresh = doc.querySelector('[data-bam-cart-page]');
            if (fresh && page) { page.innerHTML = fresh.innerHTML; page.style.opacity = ''; }
          } else { window.location.reload(); return; }
          counts(data.item_count);
        })
        .catch(function () { window.location.reload(); });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-bam-cart-page]')) return;
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var input = line.querySelector('[data-qty]');
      var q = input ? (parseInt(input.value, 10) || 1) : 1;
      if (e.target.closest('[data-inc]')) { e.preventDefault(); change(key, q + 1); }
      else if (e.target.closest('[data-dec]')) { e.preventDefault(); change(key, Math.max(0, q - 1)); }
      else if (e.target.closest('[data-remove]')) { e.preventDefault(); change(key, 0); }
    });

    document.addEventListener('change', function (e) {
      if (!e.target.closest('[data-bam-cart-page]')) return;
      if (e.target.hasAttribute && e.target.hasAttribute('data-qty')) {
        var line = e.target.closest('[data-line-key]');
        var q = parseInt(e.target.value, 10); if (isNaN(q) || q < 0) q = 0;
        change(line.getAttribute('data-line-key'), q);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bam-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bam-pdp]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.bam-pdp__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.bam-pdp__thumb'));
    var filterEnabled = root.getAttribute('data-filter-variant') === 'true';
    var zoomEnabled = root.getAttribute('data-enable-zoom') === 'true';
    var titles = (root.getAttribute('data-variant-titles') || '')
      .split('|').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);

    // Galería: cambiar imagen principal con miniaturas
    function activateMedia(id) {
      if (!id) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === id); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === id); });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { activateMedia(thumb.dataset.mediaId); updateNavState(); });
    });

    // ---- Filtrado de galería por variante (según el texto alternativo de la imagen) ----
    // Devuelve el título de la variante a la que pertenece una imagen, o null si es genérica.
    function ownerOf(alt) {
      alt = (alt || '').toLowerCase();
      for (var i = 0; i < titles.length; i++) {
        if (titles[i] && alt.indexOf(titles[i]) !== -1) return titles[i];
      }
      return null; // sin nombre de variante: se muestra siempre
    }
    function filterByVariant(selected) {
      if (!filterEnabled || !titles.length) return;
      selected = (selected || '').toLowerCase();
      function apply(el) {
        var owner = ownerOf(el.dataset.alt);
        var show = owner === null || owner === selected;
        el.classList.toggle('is-hidden', !show);
      }
      slides.forEach(apply);
      thumbs.forEach(apply);
      // Si la imagen activa quedó oculta, pasa a la primera visible.
      var active = root.querySelector('.bam-pdp__slide.is-active');
      if (!active || active.classList.contains('is-hidden')) {
        var firstVisible = slides.filter(function (s) { return !s.classList.contains('is-hidden'); })[0];
        if (firstVisible) activateMedia(firstVisible.dataset.mediaId);
      }
    }

    // ---- Variantes: al elegir, filtra galería + cambia imagen + estado del botón ----
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var soldTxt = atc ? (atc.getAttribute('data-soldout-label') || 'SOLD OUT') : '';
    var radios = Array.prototype.slice.call(root.querySelectorAll('.bam-pdp__radio'));
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        filterByVariant(radio.dataset.variantTitle);
        if (radio.dataset.mediaId) {
          var target = root.querySelector('.bam-pdp__slide[data-media-id="' + radio.dataset.mediaId + '"]');
          if (target && !target.classList.contains('is-hidden')) activateMedia(radio.dataset.mediaId);
        }
        if (atc) {
          var available = radio.dataset.available === 'true';
          atc.disabled = !available;
          if (atcLabel && !available) atcLabel.textContent = soldTxt;
        }
        updateNavState();
      });
    });

    // Estado inicial: filtra según la variante marcada de arranque.
    var checked = radios.filter(function (r) { return r.checked; })[0];
    if (checked) filterByVariant(checked.dataset.variantTitle);

    // ---- Flechas de galería (pasar fotos tocando, sin deslizar) ----
    var galPrev = root.querySelector('[data-gallery-prev]');
    var galNext = root.querySelector('[data-gallery-next]');
    function visibleSlides() {
      return slides.filter(function (s) { return !s.classList.contains('is-hidden'); });
    }
    function scrollThumbIntoView(id) {
      var t = thumbs.filter(function (x) { return x.dataset.mediaId === id; })[0];
      if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    function updateNavState() {
      if (!galPrev || !galNext) return;
      var vis = visibleSlides();
      var only = vis.length <= 1;                 // una sola foto -> ocultar flechas
      galPrev.hidden = only; galNext.hidden = only;
      var active = root.querySelector('.bam-pdp__slide.is-active');
      var idx = vis.indexOf(active);
      galPrev.disabled = idx <= 0;                 // ya estás en la primera
      galNext.disabled = idx === -1 || idx >= vis.length - 1; // ya estás en la última
    }
    function galStep(dir) {
      var vis = visibleSlides();
      var active = root.querySelector('.bam-pdp__slide.is-active');
      var idx = vis.indexOf(active);
      if (idx === -1) idx = 0;
      var target = idx + dir;
      if (target < 0 || target >= vis.length) return;
      activateMedia(vis[target].dataset.mediaId);
      scrollThumbIntoView(vis[target].dataset.mediaId);
      updateNavState();
    }
    if (galPrev) galPrev.addEventListener('click', function () { galStep(-1); });
    if (galNext) galNext.addEventListener('click', function () { galStep(1); });
    updateNavState();

    // ---- Barra de compra fija (móvil) ----
    var stickyBar = root.querySelector('[data-sticky-bar]');
    var mainAtc = root.querySelector('.bam-pdp__atc');
    if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
      var stickyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { stickyBar.classList.toggle('is-visible', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -10% 0px' });
      stickyIO.observe(mainAtc);
    } else if (stickyBar) {
      stickyBar.classList.add('is-visible');
    }
    var stickyPriceOut = root.querySelector('[data-sticky-price]');
    if (stickyPriceOut) {
      root.querySelectorAll('.bam-pdp__radio').forEach(function (r) {
        r.addEventListener('change', function () {
          var lbl = r.nextElementSibling;
          var p = lbl && lbl.querySelector('.bam-pdp__vprice strong');
          if (p) stickyPriceOut.textContent = p.textContent.trim();
        });
      });
    }

    // ---- Zoom / Lightbox ----
    if (zoomEnabled) {
      var lb = root.querySelector('[data-lightbox]');
      if (lb) {
        var lbImg = lb.querySelector('.bam-pdp__lb-img');
        function currentImg() { return root.querySelector('.bam-pdp__slide.is-active .bam-pdp__media'); }
        function openLB() {
          var img = currentImg();
          if (!img || img.tagName !== 'IMG') return; // solo imágenes (no vídeo)
          lbImg.src = img.getAttribute('data-full') || img.currentSrc || img.src;
          lbImg.alt = img.alt || '';
          lbImg.classList.remove('is-zoomed');
          lb.hidden = false;
          document.body.style.overflow = 'hidden';
        }
        function closeLB() { lb.hidden = true; lbImg.src = ''; document.body.style.overflow = ''; }
        function navLB(dir) {
          var vis = slides.filter(function (s) { return !s.classList.contains('is-hidden'); });
          var active = root.querySelector('.bam-pdp__slide.is-active');
          var idx = vis.indexOf(active);
          if (idx === -1) return;
          idx = (idx + dir + vis.length) % vis.length;
          activateMedia(vis[idx].dataset.mediaId);
          openLB();
        }
        // Abrir al pulsar la imagen principal o la lupa.
        slides.forEach(function (s) { s.addEventListener('click', function () { openLB(); }); });
        var zoomBtn = root.querySelector('[data-zoom-open]');
        if (zoomBtn) zoomBtn.addEventListener('click', function (e) { e.stopPropagation(); openLB(); });
        lb.querySelector('[data-lb-close]').addEventListener('click', closeLB);
        lb.querySelector('[data-lb-prev]').addEventListener('click', function (e) { e.stopPropagation(); navLB(-1); });
        lb.querySelector('[data-lb-next]').addEventListener('click', function (e) { e.stopPropagation(); navLB(1); });
        lb.addEventListener('click', function (e) { if (e.target === lb) closeLB(); }); // clic fuera = cerrar
        lbImg.addEventListener('click', function (e) { e.stopPropagation(); lbImg.classList.toggle('is-zoomed'); }); // clic en foto = acercar más
        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'Escape') closeLB();
          else if (e.key === 'ArrowLeft') navLB(-1);
          else if (e.key === 'ArrowRight') navLB(1);
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bam-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var COLORS = ['#FF0054', '#FFE66D', '#4ECDC4', '#8A2BE2'];
    document.querySelectorAll('[data-bam-reviews] .bam-rv-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (reduce) return;
        for (var i = 0; i < 18; i++) {
          var p = document.createElement('div');
          p.className = 'bam-rv-particle';
          p.style.background = COLORS[Math.floor(Math.random() * COLORS.length)];
          p.style.left = e.clientX + 'px';
          p.style.top = e.clientY + 'px';
          var ang = Math.random() * Math.PI * 2;
          var dist = Math.random() * 100 + 50;
          p.style.setProperty('--tx', (Math.cos(ang) * dist) + 'px');
          p.style.setProperty('--ty', (Math.sin(ang) * dist) + 'px');
          p.style.animation = 'bam-rv-scatter .6s ease-out forwards';
          document.body.appendChild(p);
          (function (el) { setTimeout(function () { el.remove(); }, 650); })(p);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bam-reviewsproduct"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bam-rw]').forEach(function (root) {
    if (root.dataset.init) return; root.dataset.init = '1';
    var list = root.querySelector('[data-rw-list]');
    var info = root.querySelector('[data-rw-info]');
    var pagesEl = root.querySelector('[data-rw-pages]');
    var prev = root.querySelector('[data-rw-prev]');
    var next = root.querySelector('[data-rw-next]');
    var sortSel = root.querySelector('[data-rw-sort]');
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 3;
    var page = 1, sort = 'recent';
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-rw-item]')).map(function (el) {
      return { el: el, rating: parseInt(el.getAttribute('data-rating'), 10) || 0, photo: parseInt(el.getAttribute('data-photo'), 10) || 0, index: parseInt(el.getAttribute('data-index'), 10) || 0 };
    });

    function apply() {
      var arr = items.slice();
      if (sort === 'highest') arr.sort(function (a, b) { return b.rating - a.rating || a.index - b.index; });
      else if (sort === 'photo') arr.sort(function (a, b) { return b.photo - a.photo || a.index - b.index; });
      else arr.sort(function (a, b) { return a.index - b.index; });
      arr.forEach(function (o) { list.appendChild(o.el); });
      var total = arr.length, pages = Math.ceil(total / perPage) || 1;
      if (page > pages) page = pages; if (page < 1) page = 1;
      var start = (page - 1) * perPage, end = Math.min(start + perPage, total);
      arr.forEach(function (o, i) { o.el.style.display = (i >= start && i < end) ? '' : 'none'; });
      if (info) info.textContent = 'Showing ' + (total ? start + 1 : 0) + '-' + end + ' of ' + total;
      if (prev) prev.disabled = page === 1;
      if (next) next.disabled = page === pages;
      if (pagesEl) {
        pagesEl.innerHTML = '';
        var show = [];
        for (var p = 1; p <= pages; p++) {
          if (p === 1 || p === pages || Math.abs(p - page) <= 1) show.push(p);
        }
        var last = 0;
        show.forEach(function (p) {
          if (p - last > 1) { var g = document.createElement('span'); g.className = 'gap'; g.textContent = '…'; pagesEl.appendChild(g); }
          (function (pp) {
            var b = document.createElement('button');
            b.textContent = pp; if (pp === page) b.className = 'is-active';
            b.addEventListener('click', function () { page = pp; apply(); scrollTop(); });
            pagesEl.appendChild(b);
          })(p);
          last = p;
        });
      }
    }
    function scrollTop() {
      var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { if (page > 1) { page--; apply(); scrollTop(); } });
    if (next) next.addEventListener('click', function () { page++; apply(); scrollTop(); });
    if (sortSel) sortSel.addEventListener('change', function () { sort = sortSel.value; page = 1; apply(); });
    apply();

    var modal = root.querySelector('[data-rw-modal]');
    root.querySelectorAll('[data-rw-open]').forEach(function (b) { b.addEventListener('click', function () { if (modal) modal.hidden = false; }); });
    if (modal) {
      root.querySelectorAll('[data-rw-close]').forEach(function (b) { b.addEventListener('click', function () { modal.hidden = true; }); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.hidden = true; });
    }
    var lb = root.querySelector('[data-rw-lightbox]');
    var lbImg = root.querySelector('[data-rw-lightbox-img]');
    var lbCap = root.querySelector('[data-rw-lightbox-cap]');
    root.querySelectorAll('[data-rw-photo]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!lb) return;
        lbImg.src = b.getAttribute('data-rw-photo');
        lbCap.textContent = 'Photo by ' + (b.getAttribute('data-rw-name') || '');
        lb.hidden = false;
      });
    });
    if (lb) {
      root.querySelectorAll('[data-rw-lightbox-close]').forEach(function (b) { b.addEventListener('click', function () { lb.hidden = true; }); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.hidden = true; });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (modal) modal.hidden = true; if (lb) lb.hidden = true; } });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bam-shipbar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ship-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var adding = btn.getAttribute('data-label-adding') || 'Adding...';
      btn.disabled = true;
      btn.textContent = adding;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-label-add') || 'Add';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bam-video-demo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-bam-vd]').forEach(function (root) {
        if (root.__vd) return; root.__vd = 1;
        var inner = root.querySelector('.bam-vd__inner');
        var v = root.querySelector('[data-vd-video]');
        var play = root.querySelector('[data-vd-play]');
        var snd = root.querySelector('[data-vd-sound]');
        var emb = root.querySelector('[data-vd-embed]');
        if (v && snd) {
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (es) {
              es.forEach(function (e) {
                if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
              });
            }, { threshold: 0.35 }).observe(v);
          }
          snd.addEventListener('click', function () {
            v.muted = !v.muted;
            snd.textContent = v.muted ? '🔇 ' + snd.getAttribute('data-label') : '🔊 ON';
            if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          });
        }
        if (v && play) {
          play.addEventListener('click', function () {
            v.muted = false; v.controls = true;
            var p = v.play(); if (p && p.catch) p.catch(function () {});
            play.hidden = true;
          });
        }
        if (emb) {
          emb.addEventListener('click', function () {
            var f = document.createElement('iframe');
            f.className = 'bam-vd__el'; f.src = emb.getAttribute('data-vd-embed');
            f.allow = 'autoplay; fullscreen; picture-in-picture'; f.allowFullscreen = true; f.title = 'Video';
            inner.appendChild(f); emb.hidden = true;
          });
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bam-videos"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bam-vids]').forEach(function (root) {
    if (root.dataset.init) return; root.dataset.init = '1';
    var autoplay = root.getAttribute('data-autoplay') === 'true';

    root.querySelectorAll('[data-bam-vid]').forEach(function (card) {
      var video = card.querySelector('[data-bam-video]');
      var play = card.querySelector('[data-bam-play]');
      var mute = card.querySelector('[data-bam-mute]');
      if (!video) return;

      function start(withSound) {
        // pausa los demás vídeos con sonido
        root.querySelectorAll('[data-bam-video]').forEach(function (v) { if (v !== video && !v.muted) { v.pause(); } });
        if (withSound) video.muted = false;
        video.setAttribute('controls', '');
        var p = video.play(); if (p && p.catch) p.catch(function () {});
        card.classList.add('is-playing');
      }
      if (play) play.addEventListener('click', function () { start(true); });
      if (mute) mute.addEventListener('click', function () { video.muted = !video.muted; mute.textContent = video.muted ? '🔇' : '🔊'; });

      if (autoplay && 'IntersectionObserver' in window) {
        video.muted = true;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
            else { video.pause(); }
          });
        }, { threshold: 0.4 });
        io.observe(video);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-bam-header]').forEach(function (header) {
    var burger = header.querySelector('.bam-header__burger');
    if (!burger) return;
    burger.addEventListener('click', function () {
      var open = header.classList.toggle('bam-header--open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('bam-header--open')) {
        header.classList.remove('bam-header--open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
